app.service('productTabServices',function(console, modal, productCardConfig, productPreviewService, productPreviewWarranty, partnerSubscriptionManager, productLimitedService, cartManager, pageConfig, front) {
	var $self, $aboutWarranty, $aboutService, $limitedService, $addWarrantyCheckbox, $servicesCheckbox, $addToCard, $warranties;
	var config;
	var activeServicesGroup = "";

	function loadSuccess(html){
		console.log('ZAŁADOWANIE ZAKŁADKI: USŁUGI');
		$self.html(html);
		setElements();
		setEvents();
	}
	function loadError(){
		console.log('BŁĄD ŁADOWANIA ZAKŁADKI');
		$self.html('<div class="tab-error">Wystąpił błąd ładowania zakładki. Prosimy spróbować później</div>');
	}
	function load(){
		if($self.length){
			config = productCardConfig.getData();
			var data={
				productId: config.id,
				outletCategoryId: config.activeOutletCategory
			};

			$.ajax({
				url:'/product-card-service.ltr',
				data:data,
				success:function(html){
					loadSuccess(html);
				},
				error:function(){
					loadError();
				}
			});
		}
	}
	function checkServiceGroup(value, group) {
		if(activeServicesGroup !== group && activeServicesGroup !== ""){
 			$servicesCheckbox.filter(':not([value='+value+'])').prop('checked',false);
 		}
 		activeServicesGroup = group;

		$addToCard.data('delivery', activeServicesGroup);
	}
	function showWarrantyTypeInfo(warrantyId) {
		modal.open('warranty-postponed-payment-info-' + warrantyId, {
			modifier: 'remodal-full-width'
		});
	}

	function showSubscriptionWarrantyTypeInfo(warrantyId) {
		modal.open('warranty-subscription-payment-info-' + warrantyId, {
			modifier: 'remodal-full-width'
		});
	}

	function unselectActiveWarranty() {
		$addWarrantyCheckbox.filter(':checked').prop('checked', false);
	}

	function showWarrantyChangeModal() {
		const modalId = $(this).data('modal-id');
		modal.open(modalId, {
			modifier: 'remodal-full-width'
		});
	}

	function handleWarrantyTypeSelect() {
		const warrantyId = $(this).data('warranty-id');

		$warranties.filter(`[data-warranty-id=${warrantyId}]`)
			.addClass('is-visible')
			.removeClass('is-hidden')
			.siblings()
			.addClass('is-hidden')
			.removeClass('is-visible');

		modal.close()
	}

	function handleAddWarrantyClick() {
		const warrantyPaymentType = $(this).data('warranty-payment-type');
		const warrantyId = $(this).val();
		const checked = $(this).is(':checked');
		const warrantyAddedFrom = $(this).closest('.remodal').length ? 'ENCOURAGEMENT_PRODUCT_CARD_MORE_INFO' : 'PRODUCT_CARD_WARRANTY_SECTION';
		

		unselectActiveWarranty();

		updateWarranties({
			warrantyPaymentType,
			warrantyId,
			checked, 
			warrantyAddedFrom
		})

		if (checked) {
			UA.pageInteraction('Usługi', 'Dodaj - Gwarancja');
		}
	}

	function setEvents() {
		$('body')
			.on('click', '.js-show-warranty-type-info', function handleShowWarrantyTypeInfoClick() {
				const warrantyId = $(this).data('warranty-id');
				showWarrantyTypeInfo(warrantyId);
			})
			.on('click', '.js-show-subscription-warranty-type-info', function handleShowSubscriptionWarrantyInfoClick() {
				const warrantyId = $(this).data('warranty-id');
				showSubscriptionWarrantyTypeInfo(warrantyId);
			})
			.on('click', '.js-change-warranty-period', showWarrantyChangeModal)
			.on('click', '.js-select-warranty-type', handleWarrantyTypeSelect)
			.on('click', '.js-add-warranty', handleAddWarrantyClick);

		$aboutWarranty.on('click', function() {
			productPreviewWarranty.init({
				warrantyId: $(this).data('warranty'),
				warrantyPaymentType: $(this).data('warranty-payment-type')
			});
			UA.pageInteraction('Usługi', 'Więcej - Gwarancja');
		});
		$aboutService.on('click', function () {
			productPreviewService.init($(this).data('service'), config.id, config.activeOutletCategory);
			UA.pageInteraction('Usługi', 'Więcej - Usługa');
		});
		$limitedService.on('click', function() {
			productLimitedService.init($(this).data('service'), config.id);
		});
		$addServiceCheckbox.on('click', function() {
			checkServiceGroup($(this).val(), $(this).data('service-group'));
			if($(this).is(':checked')) {
				UA.pageInteraction('Usługi', 'Dodaj - Usługa');
			}
		});
		$(document).on('cartReady',function(){
			checkCart()
			partnerSubscriptionManager.checkedCheck(config.id, false);
		});
		checkCart();

		partnerSubscriptionManager.checkedCheck(config.id);
	}

	function updateWarranties({ warrantyId, warrantyPaymentType, checked, warrantyAddedFrom }) {
		$addWarrantyCheckbox
			.filter(`[value=${warrantyId}]`)
			.filter(`[data-warranty-payment-type=${warrantyPaymentType}]`)
			.prop('checked', checked)
			.data('warranty-added-from', warrantyAddedFrom);
	}

	function updateSelectedWarrantyOnCartChange(currentItemId) {
		const { warrantyId, warrantyPaymentType } = cartManager.getWarranty(
			currentItemId
		);

		if (!warrantyId) return;

		updateWarranties({ warrantyId, warrantyPaymentType, checked: true });
	}

	function checkCart(){
		var servicesList = $.extend([],cartManager.getServices(config.id) ); //lista usług w koszyku

		$addServiceCheckbox.prop('checked',false);
		$(servicesList).each(function(i, service) {
			$('input.js-add-service-with-product-checkbox[value='+service+']').prop('checked',true);
		});

		unselectActiveWarranty();

		updateSelectedWarrantyOnCartChange(config.id);
	}

	function setElements(){
		$aboutWarranty = $('.js-about-warranty', $self);
		$aboutService = $('.js-about-service', $self);
		$limitedService = $('.js-limited-service', $self);
		$addWarrantyCheckbox = $('.js-add-warranty', $self);
		$addServiceCheckbox = $('.js-add-service-with-product-checkbox', $self);
		$servicesCheckbox = $('.add-service-with-product-checkbox', $self);
		$addToCard = $('.js-add-to-cart');
		$warranties = $self.find('.warranties-item');
	}
	function init(){
		$self = $('#services');
		config = productCardConfig.getData();
		load();
	}
	return {
		init:init
	};
});
